export { default as GLOBAL_SHORTCUTS } from './GlobalShortcuts';
export { default as NAVIGATION_SHORTCUTS } from './NavigationShortcuts';
export { default as Shortcut } from './Shortcut';
export * from './Shortcut';
export { default as ShortcutRegistry } from './ShortcutRegistry';
